import React from "react";
import { TransactionStatus } from "../../types";
import Successful from "../../assets/icons/transaction/successful.svg";
import Cancelled from "../../assets/icons/transaction/cancelled.svg";
import Declined from "../../assets/icons/transaction/Declined.svg";
import Pending from "../../assets/icons/transaction/pending.svg";
import Expired from "../../assets/icons/transaction/expired.svg";
import refund from "../../assets/icons/transaction/refunded.png";
import refundFailed from "../../assets/icons/transaction/refundFailed.png";
import refundInitiated from "../../assets/icons/transaction/refundInitiated.png";

const icons = {
  successful: Successful,
  cancelled: Cancelled,
  pending: Pending,
  expired: Expired,
  refunded: refund,
  refund_failed: refundFailed,
  refund_initiated: refundInitiated,
  declined: Declined
};

interface Props {
  status: TransactionStatus;
  reason?: string;
}

const TransactionIcon = ({ status, reason }: Props) => {
  const src = icons[status];
  const alt = reason && reason === 'expired_uncaptured_charge' ? "Expired" : "Transaction " + status.toLocaleLowerCase();
  const title = alt;
  const width = 15;
  const height = 15;

  if (!src) return <></>;

  const props = { src, alt, width, height, title };
  return <img {...props} />;
};

export default TransactionIcon;
